<template>
  <div class="sharepublicDialogClass">
     <div class="dia-can">
                 <vue-canvas-poster :widthPixels="370" :painting="painting" @success="shanrSuccess" @fail="fail"></vue-canvas-poster>
            </div>
            <div class="dia-btn" @click="$util.downloadFile(dowloadImgName,posterImg)">下载二维码</div>
             <div class="linkdiv" v-if="propType">
     链接：{{propQrcode}}
    <span @click.stop="copy(propQrcode)" style="color:#409eff;cursor: pointer;">复制</span>
  </div>
  </div>
</template>
<script>
export default {
      props:{
       propImg: [String, Number],
       propText: [String, Number],
       propQrcode:[String, Number],
       dowloadImgName:[String, Number],
       propType:[String, Number]
  },
    data() {
        return {
            posterImg:'',
                     painting: {
                    width: '371px',
                    height: '420px',
                    background: '#f4f5f7',
                    borderRadius:'20px',
                    views: [
                        {
                            type: 'image',
                            url: '',
                            css: {
                                top: '0px',
                                left: '0px',
                                borderRadius:'20px 20px 0 0',
                                width: '371px',
                                height: '130px'
                            },
                        },
                        {
                            type:'text',
                            text: '',
                            css: {
                                top:'140px',
                                 width: "100%",
                            textAlign: "center",
                            fontSize: "14px",
                            maxLines: "2",
                            lineHeight: "20px"
                            }
                        },
                         {
                        type: 'qrcode',
                        content: '',
                        css: {
                            top: '200px',
                            left: '110px',
                            color: '#000',
                            width: '150px',
                            height: '150px'
                        }
                        },
                          {
                            type:'text',
                            text: '技术支持：北京和隆软件有限公司',
                            css: {
                                bottom:'20px',
                                left:'0px',
                                 width: "100%",
                                textAlign: "center",
                                fontSize: "12px",
                                maxLines: "1",
                                color: '#333',
                            }
                        }
                        // ....
                    ],
                }, 
        }
    },
    created() {
        this.handleChangeImg()
    },
    methods: {
            // 复制链接
          copy(link){
             let _self = this
      this.$copyText(link).then(
        function(e) {
            _self.$message.success('复制成功')
        },
        function(e) {
         _self.$message.error('复制失败')
        }
      );
    },
       // 手动修改views
        handleChangeImg(data){
            this.painting.views[0].url = this.propImg
            this.painting.views[1].text = this.propText
             this.painting.views[2].content = this.propQrcode
        },
           shanrSuccess(src) {
            this.posterImg = src;
            },
            fail(err) {
                console.log('fail', err)
            },
    }
}
</script>
<style lang="scss" scoped>

</style>